<div class="flex flex-col w-full gap-1">
    <label [attr.for]="id" class="font-bold text-black">{{
        label
    }}</label>
    <input
        [ngClass]="{ invalid: campoInvalido, lowercase: lowercase }"
        [type]="type"
        [id]="id"
        [placeholder]="placeholder"
        [disabled]="isReadOnly || isDisabledByForm"
        [(ngModel)]="value"
        (blur)="onBlur.emit($event)"
        (keypress)="keyPress($event)"
        autocomplete="off"
        pInputText
        [maxLength]="maxLength"
        class="bg-white max-h-8 min-w-0! flex-1 border border-gray-300 px-3 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-emerald-300 rounded-lg"
    />
</div>
